<template>
  <ul class="nav nav-tabs mb-4">
    <li class="nav-item">
      <router-link class="nav-link" :to="routes.details" exact>Detail</router-link>
    </li>

    <li class="nav-item">
      <router-link
        class="nav-link"
        :to="routes.graduates"
        :class="[activeRoute('programs.graduates')]"
        exact
      >Home Agency Graduates</router-link>
    </li>
  </ul><!-- /.nav -->
</template>

<script>
import { programComputed } from 'vx/helpers'
import { startsWith } from 'lodash'

export default {
  computed: {
    ...programComputed,

    routes () {
      return {
        details: { name: 'programs.details' },
        graduates: { name: 'programs.graduates' },
        managerAssignments: { name: 'programs.managers' }
      }
    }
  },

  methods: {
    activeRoute (name) {
      if (name) {
        if (startsWith(this.$route.name, name)) {
          return 'active'
        }
      }
      return ''
    }
  }
}
</script>
